import Vue from "vue"

const ipReg =
  /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/

const defaultLang = "en_US"
// 语言映射对象
const langMap = {
  en: "en_US",
  "zh-hant": "zh_HK"
}

const dirMap = {
  0: "mpj",
  15: "wellcome",
  10: "coldStorage"
}
const facebookId = {
  0: ""
}

const _setEnvVar = (key, value) => {
  if (process.server) {
    global.__env__[key] = value
  } else {
    window.__env__[key] = value
  }
  return value
}

const _getOrigin = req => {
  if (process.server) {
    const host = req.headers["x-forwarded-host"] || req.headers.host
    const protocol = ipReg.test(host) || host.includes("localhost") ? "http" : "https"
    return `${protocol}://${host}`
  }
  return window.location.origin
}
const _setDomainFlag = (req, store) => {
  if (process.server) {
    const domainFlag = req.headers["domain-flag"] || ""
    store.commit("setDomainFlag", domainFlag)
  }
}

export const setTenantId = ({ store }) => {
  _setEnvVar("tenantId", store.state.commonParams?.dmTenantId)
}

/**
 * 获取语言
 * @param {*} $cookies
 * @param {*} route
 * @returns
 */
const _getLang = ({ $cookies, route }) => {
  const match = route.path.match(/(en|zh-hant)/)
  if (match) {
    const [key] = match
    return langMap[key] || defaultLang
  }
  return $cookies.get("superweb-locale") || defaultLang
}

export const getEnv = () => {
  if (process.server) {
    return global.__env__
  } else {
    return window.__env__
  }
}

export const getLang = () => {
  const env = getEnv()
  return env?.lang
}

export const getTenantId = () => {
  const env = getEnv()
  return env?.tenantId
}
export const getDomainFlag = () => {
  const env = getEnv()
  return env?.domainFlag
}

export const getDomain = () => {
  const env = getEnv()
  return env?.domain
}

export const getPaths = () => {
  const env = getEnv()
  return env?.paths || {}
}

export const getCommonReqParam = () => {
  const env = getEnv()
  return env?.commonReqParams || {}
}

export const getCommonParam = () => {
  const env = getEnv()
  return env?.commonParam || {}
}

export const getLocaleKey = lang => {
  const entry = Object.entries(langMap).find(([_, value]) => value === lang)
  return entry ? entry[0] : null
}

export const getTenantDir = _ => {
  const tenantId = getTenantId()
  return dirMap[tenantId] || "coldStorage"
}

export const setCommonReqParam = ({ store }) => {
  const { commonParams, storeInfo } = store.state
  return _setEnvVar("commonReqParams", {
    ...getCommonParam(),
    areaId: "",
    brandId: "",
    categorySkuId: 0,
    bannerId: "5,6",
    deliveryLat: storeInfo?.latitude || commonParams?.deliveryLat || "",
    deliveryLng: storeInfo?.longitude || commonParams?.deliveryLng || ""
  })
}

export const setCommonParam = ({ store, $cookies }) => {
  const { commonParams, resCookies } = store.state
  return _setEnvVar("commonParam", {
    dmTenantId: commonParams.dmTenantId,
    venderId: $cookies.get("venderId") || commonParams.venderId,
    businessCode: 1,
    origin: 26, // 27 for h5, 26 for pc
    "superweb-locale": getLang(),
    storeId: resCookies?.storeId || $cookies.get("store") || commonParams.storeId,
    pickUpStoreId: $cookies.get("pickUpStoreId"),
    shipmentType: $cookies.get("shipmentType") // 配送方式：1-送货，2-自提
  })
}

export const setLang = ({ store, $cookies, lang }) => {
  $cookies.set("superweb-locale", lang)
  store.commit("setLang", lang)
}

export default ({ req, route, store, $cookies }) => {
  // 根据环境设置域名
  const domain = process.server ? req.headers["x-forwarded-host"] || req.headers.host : window.location.host
  const origin = _getOrigin(req)
  const lang = _getLang({ $cookies, route })

  // 设置 MAIN_PATH 和 MAIN_ORIGIN 等环境变量
  let MAIN_PATH = ""
  const MAIN_PATH_WITHOUT_LANG = ""
  const MAIN_ORIGIN = origin
  const MAIN_ORIGIN_HOME = origin

  // 打印完整的请求头信息（仅在服务端）
  if (process.server && !req?.headers["x-forwarded-host"]) {
    console.log("  ====>Full Request Headers Debug:")
    console.log("  Route:", route?.fullPath)
    console.log("  x-forwarded-host:", req.headers["x-forwarded-host"])
    console.log("  req.headers.host:", req.headers.host)
    console.log("  x-forwarded-proto:", req.headers["x-forwarded-proto"])
    console.log("  x-forwarded-for:", req.headers["x-forwarded-for"])
    console.log("  final domain", domain)
    console.log("  MAIN_ORIGIN:", MAIN_ORIGIN)
  }

  if (ipReg.test(domain) || domain === "localhost") {
    MAIN_PATH = MAIN_PATH_WITHOUT_LANG
  } else if (lang === "zh_HK") {
    MAIN_PATH = "/zh-hant" + MAIN_PATH_WITHOUT_LANG
  } else if (lang === "en_US") {
    MAIN_PATH = "/en" + MAIN_PATH_WITHOUT_LANG
  }
  // 網站區分
  _setDomainFlag(req, store)
  setLang({ store, $cookies, lang })

  // 将环境变量注入 Vue 实例
  Vue.prototype.MAIN_PATH = MAIN_PATH
  Vue.prototype.MAIN_PATH_WITHOUT_LANG = MAIN_PATH_WITHOUT_LANG
  Vue.prototype.MAIN_ORIGIN_HOME = MAIN_ORIGIN_HOME
  Vue.prototype.MAIN_ORIGIN = MAIN_ORIGIN
  const domainFlag = store.state.domainFlag
  global.__env__ = {
    domain,
    lang,
    tenantId: 10,
    domainFlag,
    commonParam: {},
    commonReqParams: {},
    paths: {
      MAIN_PATH,
      MAIN_PATH_WITHOUT_LANG,
      MAIN_ORIGIN_HOME,
      MAIN_ORIGIN
    }
  }
}
